var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChartShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.834 16V21M12.834 16L18.834 21M12.834 16L6.83398 21M21.834 3V11.2C21.834 12.8802 21.834 13.7202 21.507 14.362C21.2194 14.9265 20.7605 15.3854 20.196 15.673C19.5542 16 18.7142 16 17.034 16H8.63398C6.95382 16 6.11374 16 5.47201 15.673C4.90752 15.3854 4.44858 14.9265 4.16096 14.362C3.83398 13.7202 3.83398 12.8802 3.83398 11.2V3M8.83398 9V12M12.834 7V12M16.834 11V12M22.834 3H2.83398",
    stroke: "#043F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChartShow);
export default __webpack_public_path__ + "static/media/ic-chart-show.e1e0dea41cd34af2d22ff8543b83b48a.svg";
export { ForwardRef as ReactComponent };